import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mx-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_AccountableAccount = _resolveComponent("AccountableAccount")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importMapping, (type, index) => {
      return (_openBlock(), _createBlock(_component_v_row, {
        "no-gutters": "",
        key: `connector-import-mapping-${index}`,
        class: "my-1",
        style: {"min-width":"850px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(type.key), 1)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_AccountableAccount, {
                modelValue: type.value,
                "onUpdate:modelValue": ($event: any) => ((type.value) = $event),
                companyId: _ctx.companyId,
                inputStyle: 'padding: 10px; margin:0px;',
                showSuggestion: false,
                showDescription: true,
                showValidation: false,
                mandatory: false,
                inAccountableAccountType: 'IncomingOutgoing',
                "hide-details": "",
                onSelectAccountableAccount: _ctx.selectAccountableAccount
              }, null, 8, ["modelValue", "onUpdate:modelValue", "companyId", "onSelectAccountableAccount"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
}